import { success } from "toastr"
import {
  FETCH_ORGANIZATIONS_REQUEST,
  FETCH_ORGANIZATIONS_SUCCESS,
  FETCH_ORGANIZATIONS_FAILURE,
  CREATE_ORGANIZATION_REQUEST,
  CREATE_ORGANIZATION_SUCCESS,
  CREATE_ORGANIZATION_FAILURE,
  UPDATE_ORGANIZATION_REQUEST,
  UPDATE_ORGANIZATION_SUCCESS,
  UPDATE_ORGANIZATION_FAILURE,
  CLEAR_ORGANIZATION_STATE,
  SET_ACTIVE_ORGANIZATION,
  RESET_ORG_FLAG,
  SET_CONSOLIDATED_VIEW,
} from "./actionTypes"

const initialState = {
  organizations: [],
  activeOrganization: {},
  loading: false,
  error: null,
  success: null,
  isConsolidatedView: false,
}

const Organization = (state = initialState, action) => {
  switch (action.type) {
    // Fetch organizations cases
    case FETCH_ORGANIZATIONS_REQUEST:
    case CREATE_ORGANIZATION_REQUEST:
    case UPDATE_ORGANIZATION_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        success: null,
      }

    case FETCH_ORGANIZATIONS_SUCCESS:
      console.log("paylaod: ", action.payload)
      return {
        ...state,
        organizations: action.payload,
        activeOrganization: action.payload[0].Organization,
        loading: false,
        success: null,
        isConsolidatedView: action.payload.length > 1 ? state.isConsolidatedView : false,
      }

    case CREATE_ORGANIZATION_SUCCESS:
      return {
        ...state,
        organizations: action.payload.assignedCompanies,
        loading: false,
      }

    case CLEAR_ORGANIZATION_STATE:
      return {
        ...state,
        organizations: [],
        activeOrganization: {},
        loading: false,
        error: null,
        success: null,
      }

    case RESET_ORG_FLAG:
      return { ...state, success: null, error: null }

    case SET_ACTIVE_ORGANIZATION:
      return {
        ...state,
        activeOrganization: action.payload, // Update the active organization
      }
    case SET_CONSOLIDATED_VIEW:
      return {
        ...state,
        isConsolidatedView: action.payload, 
      }

    case UPDATE_ORGANIZATION_SUCCESS:
      return {
        ...state,
        organizations: action.payload.assignedCompanies,
        activeOrganization:
          state.activeOrganization.id == action.payload.organization.id
            ? action.payload.organization
            : state.activeOrganization,
        loading: false,
        success: action.payload.message,
      }

    case FETCH_ORGANIZATIONS_FAILURE:
    case CREATE_ORGANIZATION_FAILURE:
    case UPDATE_ORGANIZATION_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      }

    default:
      return state
  }
}

export default Organization
